import PropTypes from "prop-types";
import React from "react";

import { fireTrack } from "@swa-ui/analytics";
import { useLocation } from "@swa-ui/browser";
import { Banner } from "@swa-ui/core";
import i18n from "@swa-ui/locale";
import { PlacementFactory, usePlacementIds } from "@swa-ui/placements";

export const RotatingBannerPanel = (props) => {
  const { placement = {}, placementData = {} } = props;
  const { analyticsValue = "" } = placementData;
  const { pathname } = useLocation();
  const placementIds = usePlacementIds(new RegExp(`${placement?.id}.*`));

  return placementIds.length > 0 && <Banner {...getBannerProps()} />;

  function getBannerProps() {
    return {
      "aria-label": i18n("RotatingBannerPanel__ARIA_LABEL"),
      "aria-label-next": i18n("RotatingBannerPanel__ARIA_LABEL_NEXT"),
      "aria-label-previous": i18n("RotatingBannerPanel__ARIA_LABEL_PREVIOUS"),
      items: placementIds.map((placementId) => getBannerItems(placementId)),
      onClick,
      width: "preset",
    };
  }

  function getBannerItems(placementId) {
    return <PlacementFactory id={placementId} />;
  }

  function onClick() {
    if (analyticsValue && pathname !== "/vacations") {
      fireTrack("squid", { page_description: analyticsValue });
    }
  }
};

RotatingBannerPanel.displayName = "RotatingBannerPanel";
RotatingBannerPanel.propTypes = {
  /** Object that displays placement content. */
  placement: PropTypes.object,

  /** Additional data to pass to the placement */
  placementData: PropTypes.object,
};
